import {
  OBTER_TELAS_DISPONIVEIS_REQUEST,
  OBTER_TELAS_DISPONIVEIS_SUCCESS,
  RESETA_TELAS_DISPONIVEIS_REQUEST,
} from './constants';

export function obterTelasDisponiveisRequest() {
  return {
    type: OBTER_TELAS_DISPONIVEIS_REQUEST,
  };
}

export function obterTelasDisponiveisSuccess(telasDisponiveis) {
  return {
    type: OBTER_TELAS_DISPONIVEIS_SUCCESS,
    payload: telasDisponiveis,
  };
}

export function resetaTelasDisponiveisRequest() {
  return {
    type: RESETA_TELAS_DISPONIVEIS_REQUEST,
  };
}
